import { styled } from '@mui/material/styles';
import Container from '@mui/material/Container';

export const SiteFrame = styled('div')({
  minHeight: '100vh',
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  maxWidth: 1440,
  marginInline: 'auto',

  '--gx': 'clamp(16px, 4.17vw, 60px)',
  '--gt': 'clamp(16px, 1.67vw, 24px)',
} as any);

export const HeaderRoot = styled('header')({
  width: '100%',
});

export const HeaderBar = styled(Container)(({ theme }) => ({
  width: '100%',
  marginInline: 'auto',

  paddingTop: 'var(--gt)',
  paddingLeft: 'var(--gx)',
  paddingRight: 'var(--gx)',

  [theme.breakpoints.down(1200)]: {
    paddingLeft: 'clamp(16px, 3.5vw, 44px)',
    paddingRight: 'clamp(16px, 3.5vw, 44px)',
    paddingTop: 'clamp(14px, 1.4vw, 20px)',
  },

  [theme.breakpoints.between(600, 899)]: {
    paddingLeft: 20,
    paddingRight: 20,
    paddingTop: 16,
  },

  [theme.breakpoints.down(600)]: {
    paddingLeft: 16,
    paddingRight: 16,
    paddingTop: 14,
  },
}));

export const LogoWrap = styled('div')(({ theme }) => ({
  position: 'relative',
  flexShrink: 0,

  width: 192.8,
  height: 60,

  [theme.breakpoints.down(1200)]: {
    width: 'clamp(160px, 16vw, 192.8px)',
    height: 'clamp(50px, 5vw, 60px)',
  },

  [theme.breakpoints.between(600, 899)]: {
    width: 170,
    height: 54,
  },

  [theme.breakpoints.down(600)]: {
    width: 150,
    height: 48,
  },

  '& > a': {
    position: 'absolute',
    inset: 0,
    display: 'block',
  },
}));

export const LogoImage = styled('img')({
  objectFit: 'contain',
  width: '100%',
  height: '100%',
});

export const MainWrap = styled('main')({
  flex: 1,
  width: '100%',
});
